import { render, staticRenderFns } from "./orderFood.vue?vue&type=template&id=1194915c"
import script from "./orderFood.vue?vue&type=script&lang=js"
export * from "./orderFood.vue?vue&type=script&lang=js"
import style0 from "./orderFood.vue?vue&type=style&index=0&id=1194915c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports